/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tickets-clear': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M13.714 8A2.286 2.286 0 0016 10.286v1.928a1.5 1.5 0 01-1.5 1.5h-13a1.5 1.5 0 01-1.5-1.5v-1.928a2.286 2.286 0 100-4.572V3.786a1.5 1.5 0 011.5-1.5h13a1.5 1.5 0 011.5 1.5v1.928A2.286 2.286 0 0013.714 8zM10.25 5l.75.75L8.75 8 11 10.25l-.75.75L8 8.75 5.75 11 5 10.25 7.25 8 5 5.75 5.75 5 8 7.25 10.25 5z" _fill="#0078D2"/>'
  }
})
